// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IDiscussionForm } from '~/utils/mockData/common';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      studentId: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      studentName: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      courseId: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      courseName: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      discussionId: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      discussionName: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      gradingPoint: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
    })
    .required();
};

export const defaultValuesForm: IDiscussionForm = {
  studentId: '',
  studentName: '',
  courseId: '',
  courseName: '',
  discussionId: '',
  discussionName: '',
  gradingPoint: '',
};
